export default class TicketsSpan {
  constructor() {
    this.els = document.querySelectorAll('span.tickets')

    this.init()

    this.init = this.init.bind(this)
    this.clearInner = this.clearInner.bind(this)
  }

  init() {
    if (!this.els) return false
    this.clearInner()
  }

  clearInner() {
    for (const el of this.els) {
      let html = el.innerHTML
      // Dont judge me!
      html = html.split('<br>').join(',').split('<h3>').join(',').split('</h3>').join(',').split('<span>').join(',').split('</span>').join(',').split('<b>').join(',').split('</b>').join(',').split(',')
      let finalHtml = ''
      html.forEach(h => finalHtml += h)
      el.innerHTML = finalHtml
    }
  }
}